import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useGetParams } from './hooks/useGetParams';

import { useVote } from './hooks/useVote';
import VoteFullSize from './components/VoteFullSize/VoteFullSize';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { useMemo } from 'react';
import defaultBackground from './assets/images/bg.png';

function App() {
  const { currentState, isVisible, voteState } = useVote();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
  } = useGetParams();
  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={isVisible && (currentState === 'S1' || currentState === 'S2')}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="advt-wrapper">
          {advt_info && <AdvtFullSize advtInfo={advt_info} />}
        </div>
      </CSSTransition>
      <CSSTransition
        in={
          isVisible &&
          (currentState === 'S1' || currentState === 'S2') &&
          !voteState?.variants
        }
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="titre-wrapper">
          {!voteState?.variants &&
            (currentState === 'S1' || currentState === 'S2') && (
              <VoteFullSize
                variants={voteState?.vars}
                title={voteState?.title}
                withResults={true}
                currentState={currentState}
                questionFontSize={questionFontSize}
                answerFontSize={answerFontSize}
                varNumFontSize={varNumFontSize}
              />
            )}
        </div>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
